module.exports = __webpack_public_path__ + "img/gachita_1_2.dbd5aaeb.png";